import axios from 'axios'
import { saveAs } from 'file-saver'
import { arrayBufferToBlob } from 'blob-util'
import contentMixin from '@/components/helpers/mixins/content-mixin'

export default {
  getContent(perPage, pageNumber, filters, sorting, withoutClassEvents) {
    const query = {
      params: {
        perPage,
        pageNumber,
        filters,
        sorting
      }
    }
    return axios.get(withoutClassEvents ? '/api/content?notAssociatedWithOrg=true' : '/api/content', query)
  },
  getAllPartners(filters) {
    const query = {
      params: {
        filters
      }
    }
    return axios.get('/api/content/partners', query)
  },
  getAllFields() {
    return axios.get('/api/fields')
  },
  getVerificationCount() {
    return axios.get('/api/content/verification/count')
  },
  getSelectedContent(contentId) {
    return axios.get(`/api/content/${contentId}`)
  },
  getSelectedClass(contentId) {
    return axios.get(`/api/content/classes/${contentId}`)
  },
  getUserClass(contentId) {
    return axios.get(`/api/content/classes/${contentId}/by-org-id`)
  },
  getSelectedPartner(contentId) {
    return axios.get(`/api/content/partners/${contentId}`)
  },
  getAllClasses(filters) {
    const query = {
      params: {
        filters
      }
    }
    return axios.get('/api/content/classes', query)
  },
  sendSavedContent(content) {
    return new Promise((resolve) => {
      contentMixin.methods
        .$_contentMixin_uploadImages(content.fullDescription).then((res) => {
          axios.put('/api/content', { ...content, fullDescription: res })
            .then((response) => {
              resolve(response)
            })
        })
    })
  },
  sendSavedContentByTeacher(content) {
    return new Promise((resolve) => {
      contentMixin.methods
        .$_contentMixin_uploadImages(content.fullDescription).then((res) => {
          axios.put('/api/content?forceTeacher=true', { ...content, fullDescription: res })
            .then((response) => {
              resolve(response)
            })
        })
    })
  },
  getOrgsForEvent(eventId) {
    return axios.get(`/api/participation/events/${eventId}/count`)
  },
  isMembers(ids, eventId) {
    return axios.post(`/api/participation/events/${eventId}`, { users: ids })
  },
  updateMemberStatus(users, eventId) {
    return axios.put(`/api/participation/events/${eventId}`, { users })
  },
  addContent(type) {
    return axios.post('/api/content', { type })
  },
  addContentByTeacher(type) {
    return axios.post('/api/content?forceTeacher=true', { type })
  },
  deleteContent(id) {
    return axios.delete(`/api/content/${id}`)
  },
  sendContentToVerification(id, text, file) {
    const fd = new FormData()
    fd.append('text', text)
    fd.append('id', id)
    if (file) {
      fd.append('file', file, file.name)
    }
    return axios.put('/api/content/review', fd)
  },
  sendContentToVerificationByTeacher(id) {
    return axios.put('/api/content/publication', { id })
  },
  sendResultOfVerification(id, status, text) {
    return axios.put('/api/content/confirmation', { id, status, text })
  },
  updateContentRating(id, isLike) {
    return axios.put(`/api/content/${id}/reaction`, { isLike })
  },
  addVoteParticipantOnEvent(id, voteData) {
    return axios.post(`/api/content/${id}/vote/participant`, { voteData })
  },
  addStudentPollForGathering(pollData) {
    return axios.post('/api/content/gathering/poll', { pollData })
  },
  getStudentPollForGathering() {
    return axios.get('/api/content/gathering/poll')
  },
  addVoteChoiceOnEvent(id, voteData) {
    return axios.post(`/api/content/${id}/vote/choice`, { voteData })
  },
  getVoteChoiceEventResults(id) {
    return axios.get(`/api/content/${id}/vote/choice`)
  },
  exportVotingParticipantExcel(contentObject) {
    const query = {
      responseType: 'arraybuffer'
    }
    return axios.get(`/api/admins/voting/xlsx/${contentObject.id}/participant`, query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data),
            response.headers['content-disposition']
              .replace('attachment; filename=', `${contentObject.title.replace(' ', '_')}-`))
        },
        (error) => {
          console.log(error)
        },
      )
  },
  exportVotingChoiceExcel(contentObject) {
    const query = {
      responseType: 'arraybuffer'
    }
    return axios.get(`/api/admins/voting/xlsx/${contentObject.id}/choice`, query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data),
            response.headers['content-disposition']
              .replace('attachment; filename=', `${contentObject.title.replace(' ', '_')}-`))
        },
        (error) => {
          console.log(error)
        },
      )
  },
  exportGatheringPollExcel() {
    const query = {
      responseType: 'arraybuffer'
    }
    return axios.get('/api/admins/gathering/xlsx/results', query)
      .then(
        (response) => {
          saveAs(arrayBufferToBlob(response.data),
            response.headers['content-disposition']
              .replace('attachment; filename=voting_choice', 'Результаты_анкетирования_к_слету'))
        },
        (error) => {
          console.log(error)
        },
      )
  }
}
